import { lazy } from "react";
import { addHandleRoute, createRoute } from "../utils/RouteHelper";

// routes
export const contractRoute = createRoute({
    path: "/contract",
    name: "menu.contract",
    icon: "grading",
    accCode: "kontrak",
});

export const contractCreateRoute = createRoute({
    path: `${contractRoute.path}/create`,
    name: "contract.add",
    icon: "",
    accCode: "kontrak",
    parentCode: contractRoute.accCode,
    action: "create",
    redirectTo: contractRoute.path,
});

export const contractEditRoute = createRoute({
    path: `${contractRoute.path}/edit`,
    name: "contract.edit",
    icon: "",
    accCode: "kontrak",
    parentCode: contractRoute.accCode,
    action: "edit",
    redirectTo: contractRoute.path,
});

export const contractViewRoute = createRoute({
    path: `${contractRoute.path}/view`,
    name: "contract.detail",
    icon: "",
    accCode: "kontrak",
    parentCode: contractRoute.accCode,
});


// component
const Contract = lazy(() => import("../page/contract/Contract"));
const ContractList = lazy(() => import("../page/contract/ContractList"));
const ContractForm = lazy(() => import("../page/contract/form/ContractForm"));
const ContractView = lazy(() => import("../page/contract/view/ContractView"));

export const contractListRoutes = [contractRoute];
export const contractMutationRoute = [contractCreateRoute, contractEditRoute, contractViewRoute];

export const contractRoutes = {
    element: <Contract />,
    children: addHandleRoute([
        { ...contractRoute, element: <ContractList /> },
        { ...contractCreateRoute, element: <ContractForm /> },
        { ...contractEditRoute, element: <ContractForm /> },
        { ...contractViewRoute, element: <ContractView /> },
    ])
}